// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"b793f875","130":"06098643","160":"fa56ade3","305":"b3f14624","316":"50615d61","439":"60e4d608","465":"83b0d575","485":"83454f4a","487":"2bb5cc2f","557":"156d5f00","658":"ae4cab2d","771":"5f226aa9","953":"80335cd8"}[chunkId] + ".chunk.js";
};